<template>
    <div>
        <div v-if="log">
        {{log}}
        </div>
        <hr/>
        <div v-if="logDATA">
        {{logDATA}}
        </div>
        
        <input type="text" v-model="idlog"/>
        <input type="text" v-model="valuelog"/>
        <s-button label="addlog" @onclick="addlog" theme="is-light"/>
         <s-button label="addData" @onclick="addData" theme="is-light"/>
        <s-button label="getlog" @onclick="getlog" theme="is-light"/>
    </div>
</template>
<script>
import firebase_api from "@/firebase/firebase_api"
import firebase from "firebase/app"

export default {
    data() {
        return {
            club: null,
            log: null,
            logDATA: null,
            idlog: "",
            valuelog: ""
        }
    },
    methods: {
        async addlog() {
            
            const setLog = async() => 
                {
                   
                    return "pp";
                }
            
            await firebase_api.api.getDb().collection("log").doc(this.idlog).set(
                        {value: this.valuelog}
                    )
            setLog().then(async ()=>{
               
                await firebase_api.api.getDb().collection("log").doc(this.idlog).collection("data").doc(this.idlog).set(
                    {valueData: this.valuelog}
                )
            }) 
        },
        async addData() {
             await firebase_api.api.getDb().collection("log").doc(this.idlog).collection("data").doc(this.idlog).set(
                    {valueData: this.valuelog}
            )   
        },
        getlog() {
            firebase_api.api.getDb().collection("log").doc(this.idlog).get().then(log=>{
                this.log=log.data();
            })
            firebase_api.api.getDb().collection("log").doc(this.idlog)
                .collection("data").doc(this.idlog).get().then(log=>{
                    this.logDATA = log.data();
                });
        }
    },
    mounted() {
         /*firebase_api.api.getDb().collection("club").doc("TEST1")
        .onSnapshot({ includeMetadataChanges: true }, function(snapshot) {
            snapshot.docChanges().forEach(function(change) {
                if (change.type === "added") {
                    this.club = change.doc.data();
                    console.log("New city: ", change.doc.data());
                }

                var source = snapshot.metadata.fromCache ? "local cache" : "server";
                console.log("Data came from " + source);
            });
        });*/
    firebase_api.api.getDb().collection("club").doc("TEST1")
         .onSnapshot({ includeMetadataChanges: true }, snapshot=>{
             this.club = snapshot.data();
             var source = snapshot.metadata.fromCache ? "local cache" : "server";
              console.log("Data came from " + source);
         })
    
        /*firebase_api.api.getDb().collection("club").doc("TEST1").get().then(test=>{
            this.club = test.data();
        })*/
    }
}
</script>